
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 2a1 1 0 10-2 0v.5h-.5a1 1 0 100 2h.5V5a1 1 0 102 0v-.5h.5a1 1 0 100-2H15V2zM20 2a1 1 0 011 1v1.5h1a1 1 0 110 2h-1V8a1 1 0 11-2 0V6.5h-1a1 1 0 110-2h1V3a1 1 0 011-1z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.433 5.761a.643.643 0 01.306.306 2.5 2.5 0 003.549 1.076.79.79 0 01.936.117c.248.25.549.448.884.576a.677.677 0 01.424.521C17.722 9.553 18.738 10.5 20 10.5c.213 0 .42-.027.618-.077.306-.078.654.061.727.369A9.6 9.6 0 112.4 13c0-4.411 2.975-8.127 7.028-9.252.298-.082.583.145.668.442.2.696.693 1.267 1.337 1.571zM9.6 10.6a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm6 1.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm.643 3.745a1.2 1.2 0 010 1.697 6 6 0 01-8.486 0 1.2 1.2 0 011.697-1.697 3.6 3.6 0 005.092 0 1.2 1.2 0 011.697 0z","fill":"#fff"}})])
          )
        }
      }
    